import { CloseOutlined } from "@ant-design/icons";
import { Drawer, DrawerProps } from "antd";
import { ReactNode } from "react";
import Skeleton from "../Skeleton/Skeleton";
import styles from "./RootDrawer.module.scss";

export interface RootDrawerProps extends DrawerProps {
  title?: ReactNode;
  headerContent?: ReactNode;
  loading?: boolean;
}

export default function RootDrawer({
  title,
  headerContent,
  children,
  loading,
  ...props
}: RootDrawerProps) {
  return (
    <Drawer
      rootClassName={styles.RootDrawer}
      width={750}
      closeIcon={false}
      {...props}
    >
      <div className={styles.header}>
        <div className={styles["modal-header"]}>
          {loading ? <Skeleton style={{ width: 200, height: 30 }} /> : title}
          {props.onClose && (
            <span
              className={styles.close}
              onClick={(e) => props.onClose?.(e)}
            >
              <CloseOutlined />
            </span>
          )}
        </div>
        {headerContent}
      </div>
      <div className={styles.wrapper}>{children}</div>
    </Drawer>
  );
}
